/** SC-06 — Rephrase the current slide (AIVA-6810). */

/** A text shape the rewrite may change: its id and its text when the slide was read. */
export interface RephraseTarget {
  id: string;
  /** For a shape inside a group: the ids of the groups holding it, outermost first. */
  groupPath?: readonly string[];
  original: string;
}

/** What the slide read found. `shapeIds` is every top-level shape on the slide, in order, for the G-3 check. */
export type RephraseReadResult =
  | { kind: "ok"; shapeIds: readonly string[]; targets: readonly RephraseTarget[] }
  | { kind: "no_text" }
  | { kind: "no_slide" }
  | { kind: "unsupported"; errorCode: string };

/** One shape's row on the card, keyed on the shape id (G-3). */
export interface SlideRewrite {
  id: string;
  /** See {@link RephraseTarget.groupPath}. */
  groupPath?: readonly string[];
  original: string;
  rewrite: string;
  /** The AI left this shape as it was: shown on the card (SC-06 AC-1), never written or counted. */
  unchanged?: true;
}

/** The rows Apply writes and the card counts. */
export function changedRewrites(card: Pick<SlideRewriteCard, "rewrites">): readonly SlideRewrite[] {
  return card.rewrites.filter((r) => !r.unchanged);
}

/** pending → the card waits for a decision; the rest are where it settles. */
export type SlideRewriteStatus = "pending" | "applying" | "applied" | "cancelled" | "stale" | "failed";

/** Stamped on the reply that carries the confirm card. */
export interface SlideRewriteCard {
  status: SlideRewriteStatus;
  /** Every top-level shape id on the slide when the card rendered, in order (G-3). */
  shapeIds: readonly string[];
  /** One row per text shape sent, in slide order. */
  rewrites: readonly SlideRewrite[];
}

/** The outcome of pressing Apply rewrites. */
export type ApplyRewritesResult =
  | { kind: "applied"; count: number }
  | { kind: "stale" }
  | { kind: "failed" };
